module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder"
  }, [(parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1) ? _c('div', {
    staticClass: "builder__errors"
  }, [_vm._v("\n    SOLD OUT\n  ")]) : _vm._e(), _vm._v(" "), _c('builder-heading', {
    attrs: {
      "price": _vm.priceHtml,
      "product": _vm.product,
      "title-additions": _vm.titleAdditions
    }
  }), _vm._v(" "), (_vm.hasCookies) ? _c('builder-actions', {
    attrs: {
      "initial-query-string": _vm.initialQueryString,
      "is-sold-out": parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1,
      "is-widescreen": true,
      "is-submitting": _vm.isSubmitting,
      "share-link": _vm.shareLink,
      "download-image-link": _vm.downloadImageLink
    },
    on: {
      "add-to-cart": function($event) {
        _vm.submit(true)
      },
      "add-to-comparison-gallery": function($event) {
        _vm.submit(false)
      },
      "clear-options": _vm.clearOptions,
      "reset-options-to-initial-query-string": function($event) {
        _vm.selectOptionsFromQueryString(_vm.initialQueryString)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "builder__details-and-steps"
  }, [_c('div', {
    staticClass: "builder__details"
  }, [_c('builder-imagery', {
    attrs: {
      "product": _vm.product,
      "imagery-layer-srcs": _vm.imageryLayerSrcs
    }
  }), _vm._v(" "), (_vm.product.guide_photo_src) ? _c('div', {
    staticClass: "builder__guide-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showGuide),
      expression: "showGuide"
    }],
    staticClass: "builder__guide-toggle-input",
    attrs: {
      "id": "guide-toggle",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showGuide) ? _vm._i(_vm.showGuide, null) > -1 : (_vm.showGuide)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showGuide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showGuide = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showGuide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showGuide = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "builder__guide-toggle-label",
    attrs: {
      "for": "guide-toggle"
    }
  }, [_vm._v("Guide")])]) : _vm._e(), _vm._v(" "), _c('builder-description', {
    attrs: {
      "product": _vm.product,
      "is-widescreen": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "builder__steps"
  }, [_c('div', {
    staticClass: "builder__steps-liner"
  }, _vm._l((_vm.draweredGroupedOptionsWithSelectedValues), function(drawer, drawerIndex) {
    return _c('div', {
      class: _vm.drawerClasses(drawerIndex)
    }, [(drawer.drawerOption !== null) ? _c('div', {
      staticClass: "builder__drawer-header"
    }, [_c('h2', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.drawerHeaderClickHandler(drawerIndex)
        }
      }
    }, [_vm._v(_vm._s(drawer.drawerOption.display_title ? drawer.drawerOption.display_title : drawer.drawerOption.title))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.drawerOptionsClasses(drawerIndex)
    }, _vm._l((drawer.options), function(option) {
      return _c('builder-option', {
        key: option.id,
        attrs: {
          "option": option,
          "is-expanded": (_vm.expandedOptionId == option.id)
        },
        on: {
          "input": _vm.selectOptionValue,
          "expand-option": function($event) {
            _vm.expandedOptionId = $event
          },
          "collapse-option": function($event) {
            _vm.expandedOptionId = null
          }
        }
      })
    }))])
  }))])]), _vm._v(" "), (_vm.hasCookies) ? _c('builder-actions', {
    attrs: {
      "initial-query-string": _vm.initialQueryString,
      "is-sold-out": parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1,
      "is-widescreen": false,
      "is-submitting": _vm.isSubmitting,
      "share-link": _vm.shareLink,
      "download-image-link": _vm.downloadImageLink
    },
    on: {
      "add-to-cart": function($event) {
        _vm.submit(true)
      },
      "add-to-comparison-gallery": function($event) {
        _vm.submit(false)
      },
      "clear-options": _vm.clearOptions,
      "reset-options-to-initial-query-string": function($event) {
        _vm.selectOptionsFromQueryString(_vm.initialQueryString)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('builder-description', {
    attrs: {
      "product": _vm.product,
      "is-widescreen": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c5a5a94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 368
// module chunks = 0